import React from 'react';
import { Progress } from 'react-sweet-progress';
import "react-sweet-progress/lib/style.css";
import './Tab2.css';


const Tab2 = () => {
    return (
        <div className='grid md:grid-cols-3 gap-20 mt-20 mx-5'>
            <div>
                <div className=' mb-20'>
                    <h3 className="text-sm font-semibold  tracking-widest mb-4 text-[#ff014f] uppercase">Features</h3>
                    <h1 className='text-4xl font-bold'>Design Skills</h1>

                    <div className='mt-10 text-white'>
                        <p>Html</p>
                        <Progress

                            percent={100}
                            theme={{
                                success: {
                                    symbol: '100%',
                                    color: 'rgb(223, 105, 180)'
                                }
                            }}
                        />
                    </div>
                    <div className='mt-10 text-white'>
                        <p>Css</p>
                        <Progress

                            percent={100}
                            theme={{
                                success: {
                                    symbol: '100%',
                                    color: 'rgb(223, 105, 180)'
                                }
                            }}
                        />
                    </div>
                    <div className='mt-10 text-white'>
                        <p>Bootstrap</p>
                        <Progress

                            percent={100}
                            theme={{
                                success: {
                                    symbol: '100%',
                                    color: 'rgb(223, 105, 180)'
                                }
                            }}
                        />
                    </div>
                    <div className='mt-10 text-white'>
                        <p>Tailwindcss</p>
                        <Progress

                            percent={100}
                            theme={{
                                success: {
                                    symbol: '100%',
                                    color: 'rgb(223, 105, 180)'
                                }
                            }}
                        />
                    </div>
                    <div className='mt-10 text-white'>
                        <p>React.js</p>
                        <Progress

                            percent={95}
                            theme={{
                                success: {
                                    symbol: '100%',
                                    color: 'rgb(223, 105, 180)'
                                }
                            }}
                        />
                    </div>
                    <div className='mt-10 text-white'>
                        <p>NextJS</p>
                        <Progress

                            percent={95}
                            theme={{
                                success: {
                                    symbol: '100%',
                                    color: 'rgb(223, 105, 180)'
                                }
                            }}
                        />
                    </div>
                    <div className='mt-10 text-white'>
                        <p>VueJS</p>
                        <Progress

                            percent={100}
                            theme={{
                                success: {
                                    symbol: '100%',
                                    color: 'rgb(223, 105, 180)'
                                }
                            }}
                        />
                    </div>
                    <div className='mt-10 text-white'>
                        <p>NuxtJS</p>
                        <Progress

                            percent={95}
                            theme={{
                                success: {
                                    symbol: '100%',
                                    color: 'rgb(223, 105, 180)'
                                }
                            }}
                        />
                    </div>

                    <div className='mt-10 text-white'>
                        <p>PHP</p>
                        <Progress

                            percent={90}
                            theme={{
                                success: {
                                    symbol: '100%',
                                    color: 'rgb(223, 105, 180)'
                                }
                            }}
                        />
                    </div>

                    <div className='mt-10 text-white'>
                        <p>jQuery</p>
                        <Progress

                            percent={95}
                            theme={{
                                success: {
                                    symbol: '100%',
                                    color: 'rgb(223, 105, 180)'
                                }
                            }}
                        />
                    </div>
                    <div className='mt-10 text-white'>
                        <p>Redux</p>
                        <Progress

                            percent={90}
                            theme={{
                                success: {
                                    symbol: '100%',
                                    color: 'rgb(223, 105, 180)'
                                }
                            }}
                        />
                    </div>


                </div>
            </div>






            <div>
                <div className=' mb-20'>
                    <h3 className="text-sm font-semibold  tracking-widest mb-4 text-[#ff014f] uppercase">Features</h3>
                    <h1 className='text-4xl font-bold'>Development Skills</h1>



                    <div className='mt-10 text-white'>
                        <p>Javascript</p>
                        <Progress

                            percent={85}
                            theme={{
                                success: {
                                    symbol: '100%',
                                    color: 'rgb(223, 105, 180)'
                                }
                            }}
                        />
                    </div>

                    <div className='mt-10 text-white'>
                        <p>Typescript</p>
                        <Progress

                            percent={80}
                            theme={{
                                success: {
                                    symbol: '100%',
                                    color: 'rgb(223, 105, 180)'
                                }
                            }}
                        />
                    </div>
                    <div className='mt-10 text-white'>
                        <p>Node.js</p>
                        <Progress

                            percent={80}
                            theme={{
                                success: {
                                    symbol: '100%',
                                    color: 'rgb(223, 105, 180)'
                                }
                            }}
                        />
                    </div>
                    <div className='mt-10 text-white'>
                        <p>Express.js</p>
                        <Progress

                            percent={85}
                            theme={{
                                success: {
                                    symbol: '100%',
                                    color: 'rgb(223, 105, 180)'
                                }
                            }}
                        />
                    </div>
                    <div className='mt-10 text-white'>
                        <p>MongoDB</p>
                        <Progress

                            percent={90}
                            theme={{
                                success: {
                                    symbol: '100%',
                                    color: 'rgb(223, 105, 180)'
                                }
                            }}
                        />
                    </div>
                    <div className='mt-10 text-white'>
                        <p>OOP</p>
                        <Progress

                            percent={80}
                            theme={{
                                success: {
                                    symbol: '100%',
                                    color: 'rgb(223, 105, 180)'
                                }
                            }}
                        />
                    </div>
                    <div className='mt-10 text-white'>
                        <p>MySQl</p>
                        <Progress

                            percent={80}
                            theme={{
                                success: {
                                    symbol: '100%',
                                    color: 'rgb(223, 105, 180)'
                                }
                            }}
                        />
                    </div>
                    <div className='mt-10 text-white'>
                        <p>Laravel</p>
                        <Progress

                            percent={90}
                            theme={{
                                success: {
                                    symbol: '100%',
                                    color: 'rgb(223, 105, 180)'
                                }
                            }}
                        />
                    </div>
                    <div className='mt-10 text-white'>
                        <p>WordPress</p>
                        <Progress

                            percent={100}
                            theme={{
                                success: {
                                    symbol: '100%',
                                    color: 'rgb(223, 105, 180)'
                                }
                            }}
                        />
                    </div>

                    <div className='mt-10 text-white'>
                        <p>Shopify</p>
                        <Progress

                            percent={100}
                            theme={{
                                success: {
                                    symbol: '100%',
                                    color: 'rgb(223, 105, 180)'
                                }
                            }}
                        />
                    </div>
                </div>
            </div>



            <div>
                <div className=' mb-20'>
                    <h3 className="text-sm font-semibold  tracking-widest mb-4 text-[#ff014f] uppercase">Features</h3>
                    <h1 className='text-4xl font-bold'>Marketing Skills</h1>

                    <div className='mt-10 text-white'>
                        <p>Facebook Marketing</p>
                        <Progress

                            percent={100}
                            theme={{
                                success: {
                                    symbol: '100%',
                                    color: 'rgb(223, 105, 180)'
                                }
                            }}
                        />
                    </div>
                    <div className='mt-10 text-white'>
                        <p>Google Marketing</p>
                        <Progress

                            percent={100}
                            theme={{
                                success: {
                                    symbol: '100%',
                                    color: 'rgb(223, 105, 180)'
                                }
                            }}
                        />
                    </div>
                    <div className='mt-10 text-white'>
                        <p>Instagram Marketing</p>
                        <Progress

                            percent={100}
                            theme={{
                                success: {
                                    symbol: '100%',
                                    color: 'rgb(223, 105, 180)'
                                }
                            }}
                        />
                    </div>
                    <div className='mt-10 text-white'>
                        <p>Twitter Marketing</p>
                        <Progress

                            percent={100}
                            theme={{
                                success: {
                                    symbol: '100%',
                                    color: 'rgb(223, 105, 180)'
                                }
                            }}
                        />
                    </div>
                    <div className='mt-10 text-white'>
                        <p>Linkedin Marketing</p>
                        <Progress

                            percent={95}
                            theme={{
                                success: {
                                    symbol: '100%',
                                    color: 'rgb(223, 105, 180)'
                                }
                            }}
                        />
                    </div>

                    <div className='mt-10 text-white'>
                        <p>Pinterest Marketing</p>
                        <Progress

                            percent={90}
                            theme={{
                                success: {
                                    symbol: '100%',
                                    color: 'rgb(223, 105, 180)'
                                }
                            }}
                        />
                    </div>
                    <div className='mt-10 text-white'>
                        <p>Email Marketing</p>
                        <Progress

                            percent={95}
                            theme={{
                                success: {
                                    symbol: '100%',
                                    color: 'rgb(223, 105, 180)'
                                }
                            }}
                        />
                    </div>
                    <div className='mt-10 text-white'>
                        <p>Youtube Marketing</p>
                        <Progress

                            percent={95}
                            theme={{
                                success: {
                                    symbol: '100%',
                                    color: 'rgb(223, 105, 180)'
                                }
                            }}
                        />
                    </div>
                    <div className='mt-10 text-white'>
                        <p>Shopify Dropshipping Marketing</p>
                        <Progress

                            percent={95}
                            theme={{
                                success: {
                                    symbol: '100%',
                                    color: 'rgb(223, 105, 180)'
                                }
                            }}
                        />
                    </div>


                </div>
            </div>



        </div>
    );
};

export default Tab2;